import api from "../../lib/axios";

/**
 * BookingsService — talks to Strapi via the shared interceptor in
 * src/lib/axios.js. Both reads here are intended for an authenticated
 * customer viewing their own bookings, so the user's JWT is the right
 * credential (replaces the previous baked-in REACT_APP_API_KEY).
 */

class BookingsService {
    async getBookingDetailsByUserId(user_id) {
        const qs = require("qs");
        const query = qs.stringify(
            {
                populate: "*",
                filters: {
                    users_permissions_user: {
                        id: {
                            $eq: user_id,
                        },
                    },
                },
                sort: ["BookingDate:desc"],
                publicationState: "preview",
            },
            {
                encodeValuesOnly: true,
            }
        );

        return api.get("tee-time-booking-details?" + query);
    }

    async getDefaultMembership() {
        const qs = require("qs");
        const query = qs.stringify({
            filters: {
                IsDefault: true,
            },
        });

        return api.get("memberships/?" + query);
    }
}

export default new BookingsService();
